module.exports = __webpack_public_path__ + "static/img/the-force-awakens.9d09e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/the-force-awakens.jpg
// module id = sSv9
// module chunks = 0